import { createEnums, combineEnums } from './helpers';
import {
  AGGREGATION_AXIS_COLUMN_VALUES,
  ADVERTISING_TITLE_COLUMN_VALUES,
  FILTER_COMPARISON_OPERATORS,
  OTHER_COLUMN_VALUES,
  OUTPUT_COLUMN_TABS,
  PERIOD_OPTION_VALUES,
  EXPORT_TYPE_OPTION_VALUES,
  SHOW_HEADER_ROW_OPTION_VALUES,
  SORT_DIRECTION_OPTION_VALUES,
  INTERVAL_OPTION_VALUES,
  STRING_CONTENT_VARIABLE_OPTION_VALUES,
  DAY_OF_WEEK_OPTION_VALUES,
  STATUS_VALUES,
  UNSELECTABLE_FILTER_COLUMNS,
  UNSELECTABLE_SORT_COLUMNS,
} from '../constants/SpreadsheetReportConfigs';

const scope = 'frontend.enums.SpreadsheetReportConfigs';

export const PeriodOptions = createEnums(PERIOD_OPTION_VALUES, {
  scope: `${scope}.PeriodOptions`,
});

export const ExportTypeOptions = createEnums(EXPORT_TYPE_OPTION_VALUES, {
  scope: `${scope}.ExportTypeOptions`,
});

export const ShowHeaderRowOptions = createEnums(SHOW_HEADER_ROW_OPTION_VALUES, {
  scope: `${scope}.ShowHeaderRowOptions`,
});

export const OtherColumn = createEnums(OTHER_COLUMN_VALUES, {
  scope: `${scope}.OtherColumn`,
});

export const AggregationAxisColumn = createEnums(
  AGGREGATION_AXIS_COLUMN_VALUES,
  {
    scope: `${scope}.AggregationAxisColumn`,
  }
);

export const AdvertisingTitleColumn = createEnums(
  ADVERTISING_TITLE_COLUMN_VALUES,
  {
    scope: `${scope}.AdvertisingTitleColumn`,
  }
);

export const SelectableFilterColumns = (() => {
  const selectableAggregationAxisColumns = Object.fromEntries(
    Object.entries(AGGREGATION_AXIS_COLUMN_VALUES).filter(
      ([_key, value]) => !UNSELECTABLE_FILTER_COLUMNS.includes(value)
    )
  );

  return combineEnums([
    {
      values: selectableAggregationAxisColumns,
      scope: `${scope}.AggregationAxisColumn`,
    },
    {
      values: ADVERTISING_TITLE_COLUMN_VALUES,
      scope: `${scope}.AdvertisingTitleColumn`,
    },
  ]);
})();

export const SelectableSortColumns = (() => {
  const selectableAggregationAxisColumns = Object.fromEntries(
    Object.entries(AGGREGATION_AXIS_COLUMN_VALUES).filter(
      ([_key, value]) => !UNSELECTABLE_SORT_COLUMNS.includes(value)
    )
  );

  return combineEnums([
    {
      values: selectableAggregationAxisColumns,
      scope: `${scope}.AggregationAxisColumn`,
    },
    {
      values: ADVERTISING_TITLE_COLUMN_VALUES,
      scope: `${scope}.AdvertisingTitleColumn`,
    },
  ]);
})();

export const FilterComparisonOperators = createEnums(
  FILTER_COMPARISON_OPERATORS,
  {
    scope: `${scope}.FilterComparisonOperators`,
  }
);

const createColumnToTabMap = () => ({
  ...Object.fromEntries(
    Object.values(AggregationAxisColumn).map((col) => [
      col.value,
      OUTPUT_COLUMN_TABS.aggregationAxis,
    ])
  ),
  ...Object.fromEntries(
    Object.values(AdvertisingTitleColumn).map((col) => [
      col.value,
      OUTPUT_COLUMN_TABS.advertisingTitle,
    ])
  ),
  ...Object.fromEntries(
    Object.values(OtherColumn).map((col) => [
      col.value,
      OUTPUT_COLUMN_TABS.other,
    ])
  ),
});

export const ColumnToTabMap = createColumnToTabMap();

export const SortDirectionOptions = createEnums(SORT_DIRECTION_OPTION_VALUES, {
  scope: `${scope}.SortDirectionOptions`,
});

export const IntervalOptions = createEnums(INTERVAL_OPTION_VALUES, {
  scope: `${scope}.IntervalOptions`,
});

export const StringContentVariableOptions = createEnums(
  STRING_CONTENT_VARIABLE_OPTION_VALUES,
  {
    scope: `${scope}.StringContentVariableOptions`,
  }
);

export const DayOfWeekOptions = createEnums(DAY_OF_WEEK_OPTION_VALUES, {
  scope: `${scope}.DayOfWeekOptions`,
});

export const StatusValues = createEnums(STATUS_VALUES, {
  scope: `${scope}.StatusValues`,
});
